import proj4 from 'proj4'

if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.proj4 = window.proj4 || proj4
}

export default proj4
